import styled from 'styled-components';
import { animated } from 'react-spring';
import { Button } from '../Button';

export const Container = styled(animated.section)`
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  overflow: visible;
  z-index: 999999;

  .errorMessage {
    color: ${(props) => props.theme.colors.errorMessageTextColor};
  }
`;

export const Panel = styled.div`
  background-color: ${(props) => props.theme.colors.modalBackgroundColor};
  max-width: 1100px;
  width: ${(props) => (props.width ? props.width : '100%')};
  border-radius: 20px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.05);

  @media(max-width: 600px) {
    border-radius: 0;
    height: 100%;
    width: 100%;
    display: flex;
    /* justify-content: space-between; */
    flex-direction: column;
  };

  .input-label {
    display: block;
    margin-bottom: 20px;
    color: ${(props) => props.theme.colors.modalTitleColor};
    font-size: 1.4rem;
    font-weight: 400;
    line-height: 16px;
  }

`;

export const Header = styled.div`
  padding: 20px 20px;
  width: ${(props) => (props.width ? props.width : '100%')};
  border-bottom: ${(props) => (props.borderTitle ? props.borderTitle : `2px solid ${props.theme.colors.modalTitleBorderColor}`)};  
  display: ${(props) => (props.hide ? 'none' : 'flex')};
  align-items: center;
`;

export const Title = styled.h1`
  display: flex;
  font-size: 1.4rem !important;
  margin: 0 0 0 2% !important;
  color: ${(props) => props.theme.colors.modalTitleColor} !important;
  font-weight: ${(props) => (props.fontWeightTitle ? props.fontWeightTitle : 'bold')};
  .icon-wrapper {
    width: 15px;
    height: 17px;
    margin-right: 13px;
    .icon {
      fill: ${(props) => props.theme.colors.modalTitleColor} !important;
    }
  }
`;

export const SubHead = styled.div`
  flex: 1;
  font-size: 1.2rem !important;
  margin: 0 !important;
  color: ${(props) => props.theme.colors.modalTitleColor} !important;
`;

export const Tabs = styled.ul`
  display: flex;
  width: 30%;
  align-items: center;
  font-size: 1.2rem;
  margin-left: auto;
  margin-right: 2%;
`;

export const Tab = styled.li`
  flex: 1;
  border-bottom: 4px solid ${(props) => props.theme.colors.ModalTabInativeBottomColor};

  button {
    color: ${(props) => props.theme.colors.ModalTabInativeColor};
  }

  &.active {
    border-bottom: 4px solid  ${(props) => props.theme.colors.ModalTabActiveColor};

    button {
      color:  ${(props) => props.theme.colors.ModalTabActiveColor};
    }
  }
`;

export const TabAction = styled(Button)`
  width: 100%;
  text-transform: inherit;
  padding: 0;

  &:hover{
    border-radius: 0px;
  };
`;

export const Body = styled.div`
  padding: 20px 20px;
  min-height: ${(props) => (props.contentHeight ? 'auto' : '300px')};
  height: ${(props) => (props.contentHeight ? props.contentHeight : '450px')};
  overflow-x: auto;
  overflow-y: auto;
  display: ${(props) => (props.bodyDisplayType ? props.bodyDisplayType : 'flex')};
  align-items: inherit;
  width: 96%;
  justify-content: center;
  margin-left: 2%;
  @media(max-height: 715px) {
    max-height: ${(props) => (props.contentHeight ? '450px' : '450px')};
  }
  @media(max-height: 615px) {
    max-height: ${(props) => (props.contentHeight ? '400px' : '450px')};
  }
  .inputsearch {
    height: 35px;
  }
`;

export const Actions = styled.div`
  padding: 20px 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${(props) => props.btnPosition};
`;

export const ItemsEmpty = styled.div`
  padding: 0px 24px;
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
  height: ${(props) => (props.contentHeight ? props.contentHeight : '450px')};
`;
